export const OnlineCoursesResourcesDA = {
  title: "Online kurser",
  intro:
    "Deltag i Aidas online foredrag og få viden og værktøjer til hverdagen med skærme og digitale medier.",

  course1Title: "ADHD og skærmtid - udfordringer og konsekvenser",
  course1Description:
    "Få faglig viden om, hvordan skærmtid kan påvirke børn og unge med ADHD – og brug den aktivt i dialogen med børn, unge og forældre.",
  course1Url:
    "https://seminarer.dk/products/adhd-og-skaermtid-udfordringer-og-konsekvenser?variant=53256589050198",

  // Course 2: Koncentracija
  course2Title: "Koncentration og fokus i den digitale verden",
  course2Description:
    "Hvorfor er det blevet sværere at læse en bog – og hvordan har skærme bidraget til, at vores fokus er blevet svagere?",
  course2Extended:
    "Dette online foredrag forklarer, hvordan vores opmærksomhed er truet i den digitale tid – og bringer strategier til at få koncentration og dybere fokus tilbage. Mange bemærker i dag, at de har svært ved at læse en bog uden afbrydelser – og lærere rapporterer oftere, at elever har problemer med at holde opmærksomheden i længere tid. Det er ikke tilfældigt: vores koncentration formes og trænes af det miljø, vi lever i. I en digital verden fuld af forstyrrelser bliver det stadig sværere at opretholde fokus og vie sig dybere opmærksomhed.",

  // Course 3: Class agreements
  course3Title: "Sunde rammer om børns skærmbrug – aftaler i klassen",
  course3Description:
    "Mange forældre er i tvivl om, hvornår børn skal have en telefon – og hvilke apps der er passende.",
  course3Extended:
    "Forældre står ofte i tvivl om, hvornår deres barn skal have sin første telefon, og hvilke apps der er hensigtsmæssige. Hvis man ikke tager stilling, sker det ofte, at enkelte børn får meget tidlig adgang til telefoner og sociale medier – og det skaber et stærkt gruppepres i klassen. Derfor er det en fordel at tage diskussionen i fællesskab på klasseniveau og lave fælles aftaler. Når forældre står sammen, bliver det lettere at skabe klare rammer, og børnene bliver ikke sat under det samme pres.",

  // Course 4: ADHD autizam
  course4Title: "Skærm, ADHD og autisme",
  course4Description:
    "Er skærm virkelig en pause for den neurodivergente hjerne?",
  course4Extended:
    "Børn og unge med ADHD og autisme har ofte et langt højere skærmforbrug end deres jævnaldrende – og samtidig en markant større risiko for at udvikle afhængighed. I dette online foredrag får du et overblik over den nyeste forskning om skærmtid og neurodivergens, indsigt i hvorfor skærmen ikke er en reel pause for hjernen, og konkrete redskaber til at reducere skærmtiden og skabe sundere rammer i hverdagen.",

  enrollButton: "Tilmeld dig",
  learnMoreButton: "Læs mere",
  showLess: "Vis mindre",
};

export const OnlineCoursesResourcesEN = {
  title: "Online Courses",
  intro:
    "Join Aida's online lectures and gain knowledge and tools for everyday life with screens and digital media.",

  course1Title: "ADHD and screen time – challenges and consequences",
  course1Description:
    "Gain professional knowledge about how screen time can affect children and young people with ADHD – and use it actively in dialogue with children, young people and parents.",
  course1Url:
    "https://seminarer.dk/products/adhd-og-skaermtid-udfordringer-og-konsekvenser?variant=53256589050198",

  // Course 2: Koncentracija
  course2Title: "Concentration and focus in the digital world",
  course2Description:
    "Why has it become harder to read a book – and how have screens contributed to our focus becoming weaker?",
  course2Extended:
    "This online lecture explains how our attention is threatened in the digital age – and brings strategies to regain concentration and deeper focus. Many people today notice that they have difficulty reading a book without interruptions – and teachers increasingly report that students have problems maintaining attention for longer periods. This is not coincidental: our concentration is shaped and trained by the environment we live in. In a digital world full of distractions, it becomes increasingly difficult to maintain focus and devote deeper attention.",

  // Course 3: Class agreements
  course3Title:
    "Healthy screen rules for children – agreements in the classroom",
  course3Description:
    "Many parents are unsure when their child should get a phone – and which apps are appropriate.",
  course3Extended:
    "Parents are often uncertain about the right time to give their child a first phone and which apps are suitable. When no clear agreement is made, some children are given smartphones and social media too early – and this quickly creates peer pressure for the entire class. This is why it makes sense to discuss the issue collectively at class level and agree on shared rules. When parents stand together, it becomes easier to set clear boundaries, and children are less exposed to pressure.",

  // Course 4: ADHD autizam
  course4Title: "Screen, ADHD and autism",
  course4Description:
    "Is screen time really a break for the neurodivergent brain?",
  course4Extended:
    "Children and young people with ADHD and autism often spend far more time on screens than their peers – and face a significantly higher risk of developing screen addiction. In this online lecture, you will get an overview of the latest research on screen time and neurodivergence, insights into why screen time is not truly a break for the brain, and practical tools to reduce screen use and create healthier boundaries in everyday life.",

  enrollButton: "Enroll",
  learnMoreButton: "Learn more",
  showLess: "Show less",
};

export const OnlineCoursesResourcesDE = {
  title: "Online-Kurse",
  intro:
    "Nehmen Sie an Aidas Online-Vorträgen teil und erhalten Sie Wissen und Werkzeuge für den Alltag mit Bildschirmen und digitalen Medien.",

  course1Title: "ADHS und Bildschirmzeit – Herausforderungen und Folgen",
  course1Description:
    "Erhalten Sie fachliches Wissen darüber, wie Bildschirmzeit Kinder und Jugendliche mit ADHS beeinflussen kann – und nutzen Sie es aktiv im Gespräch mit Kindern, Jugendlichen und Eltern.",
  course1Url:
    "https://seminarer.dk/products/adhd-og-skaermtid-udfordringer-og-konsekvenser?variant=53256589050198",

  // Course 2: Koncentracija
  course2Title: "Konzentration und Fokus in der digitalen Welt",
  course2Description:
    "Warum ist es schwieriger geworden, ein Buch zu lesen – und wie haben Bildschirme dazu beigetragen, dass unser Fokus schwächer geworden ist?",
  course2Extended:
    "Dieser Online-Vortrag erklärt, wie unsere Aufmerksamkeit im digitalen Zeitalter bedroht ist – und bringt Strategien, um Konzentration und tieferen Fokus zurückzugewinnen. Viele bemerken heute, dass es ihnen schwerfällt, ein Buch ohne Unterbrechungen zu lesen – und Lehrer berichten zunehmend, dass Schüler Probleme haben, die Aufmerksamkeit länger aufrechtzuerhalten. Das ist kein Zufall: Unsere Konzentration wird durch die Umgebung geprägt und trainiert, in der wir leben. In einer digitalen Welt voller Ablenkungen wird es zunehmend schwieriger, den Fokus zu behalten und sich tieferer Aufmerksamkeit zu widmen.",

  // Course 3: Class agreements
  course3Title:
    "Gesunde Bildschirmregeln für Kinder – Absprachen in der Klasse",
  course3Description:
    "Viele Eltern sind unsicher, wann ihr Kind ein Handy bekommen sollte – und welche Apps geeignet sind.",
  course3Extended:
    "Eltern sind häufig unsicher, wann der richtige Zeitpunkt für das erste Handy ist und welche Apps sinnvoll sind. Wenn keine bewusste Entscheidung getroffen wird, erhalten manche Kinder sehr früh Zugang zu Smartphones und sozialen Medien – und das erzeugt erheblichen Gruppendruck in der Klasse. Deshalb ist es sinnvoll, das Thema auf Klassenebene gemeinsam zu besprechen und Absprachen zu treffen. Wenn Eltern zusammenhalten, wird es leichter, klare Regeln aufzustellen, und die Kinder stehen weniger unter Druck.",

  // Course 4: ADHD autizam
  course4Title: "Bildschirm, ADHS und Autismus",
  course4Description:
    "Ist Bildschirmzeit wirklich eine Pause für das neurodivergente Gehirn?",
  course4Extended:
    "Kinder und Jugendliche mit ADHS und Autismus verbringen oft deutlich mehr Zeit vor Bildschirmen als ihre Gleichaltrigen – und haben ein wesentlich höheres Risiko, eine Abhängigkeit zu entwickeln. In diesem Online-Vortrag erhalten Sie einen Überblick über die neuesten Forschungsergebnisse zu Bildschirmzeit und Neurodivergenz, Einblicke, warum Bildschirmzeit keine echte Pause für das Gehirn ist, und konkrete Werkzeuge, um die Nutzung zu reduzieren und gesündere Rahmenbedingungen im Alltag zu schaffen.",

  enrollButton: "Anmelden",
  learnMoreButton: "Mehr erfahren",
  showLess: "Weniger anzeigen",
};

export const OnlineCoursesResourcesBS = {
  title: "Online kursevi",
  intro:
    "Pridružite se Aidinim online predavanjima i steknite znanje i alate za svakodnevni život s ekranima i digitalnim medijima.",

  course1Title: "ADHD i vrijeme pred ekranom – izazovi i posljedice",
  course1Description:
    "Steknite stručno znanje o tome kako vrijeme pred ekranom može uticati na djecu i mlade s ADHD-om – i koristite ga aktivno u razgovoru s djecom, mladima i roditeljima.",
  course1Url:
    "https://seminarer.dk/products/adhd-og-skaermtid-udfordringer-og-konsekvenser?variant=53256589050198",

  // Course 2: Koncentracija
  course2Title: "Koncentracija i fokus u digitalnom svijetu",
  course2Description:
    "Zašto nam je postalo teže pročitati knjigu – i kako su ekrani doprinijeli tome da nam fokus oslabi?",
  course2Extended:
    "Ovo online predavanje objašnjava kako je naša pažnja ugrožena u digitalnom dobu – i donosi strategije za povratak koncentracije i dubljeg fokusa. Mnogi danas primjećuju da im je teško pročitati knjigu bez prekida – a nastavnici sve češće izvještavaju da učenici imaju problema da duže zadrže pažnju. To nije slučajno: naša koncentracija oblikuje se i trenira okruženjem u kojem živimo. U digitalnom svijetu punom ometanja postaje sve teže održati fokus i posvetiti se dubljoj pažnji.",

  // Course 3: Class agreements
  course3Title:
    "Zdravi okviri za korištenje ekrana kod djece – dogovori u razredu",
  course3Description:
    "Mnogi roditelji nisu sigurni kada dijete treba dobiti telefon – niti koje su aplikacije primjerene.",
  course3Extended:
    "Roditelji se često pitaju kada je pravo vrijeme za prvi telefon i koje aplikacije su prikladne. Ako se ne donese svjesna odluka, onda neka djeca vrlo rano dobiju pristup telefonima i društvenim mrežama – što stvara snažan pritisak među vršnjacima u razredu. Zato je važno razgovarati na nivou razreda i donijeti zajedničke dogovore. Kada roditelji djeluju zajedno, lakše je postaviti jasne granice i djeca nisu izložena tolikom pritisku.",

  // Course 4: ADHD autizam
  course4Title: "Ekran, ADHD i autizam",
  course4Description:
    "Da li je vrijeme pred ekranom stvarno pauza za neurodivergentni mozak?",
  course4Extended:
    "Djeca i mladi s ADHD-om i autizmom često provode znatno više vremena pred ekranima nego njihovi vršnjaci – i imaju mnogo veći rizik da razviju ovisnost. Na ovom online predavanju dobit ćete pregled najnovijih istraživanja o vremenu pred ekranom i neurodivergenciji, uvid u to zašto ekran nije stvarna pauza za mozak, i konkretne alate za smanjenje korištenja ekrana i stvaranje zdravijih okvira u svakodnevnom životu.",

  enrollButton: "Prijavi se",
  learnMoreButton: "Saznaj više",
  showLess: "Prikaži manje",
};
